<template>
  <el-image
    :src="realSrc"
    fit="cover"
    :style="{ width: width + 'px', height: height + 'px' }"
    :preview-src-list="realSrcList"
    :initial-index="index"
    show-progress
    preview-teleported
    hide-on-click-modal
    :z-index="99999"
  >
    <template #error>
      <div class="image-slot">
        <el-icon><PictureFilled /></el-icon>
      </div>
    </template>
  </el-image>
</template>

<script setup>
import { computed } from 'vue'
import { PictureFilled } from '@element-plus/icons-vue'
import { isExternal } from '@/utils/validate'

/* props */
const props = defineProps({
  /** 单图或逗号分隔的字符串 */
  src: {
    type: String,
    default: ''
  },
  /** 完整图片数组（推荐） */
  list: {
    type: Array,
    default: () => []
  },
  /** 当前图片索引 */
  index: {
    type: Number,
    default: 0
  },
  width: {
    type: [Number, String],
    default: 80
  },
  height: {
    type: [Number, String],
    default: 80
  }
})

/* OSS 前缀 */
const baseUrl = 'https://dev-qa.oss-cn-beijing.aliyuncs.com'

/* 统一处理预览列表 */
const realSrcList = computed(() => {
  if (props.list.length) {
    return props.list
      .filter(Boolean)
      .map(item => (isExternal(item) ? item : `${baseUrl}/${item}`))
  }

  if (!props.src) return []

  return props.src
    .split(',')
    .filter(Boolean)
    .map(item => (isExternal(item) ? item : `${baseUrl}/${item}`))
})

/* 当前缩略图 */
const realSrc = computed(() => {
  return realSrcList.value[props.index] || ''
})
</script>

<style scoped lang="scss">
.el-image {
  border-radius: 6px;
  background-color: #ebeef5;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.15);

  :deep(.el-image__inner) {
    cursor: pointer;
    transition: transform 0.3s ease;

    &:hover {
      transform: scale(1.15);
    }
  }

  .image-slot {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    color: #909399;
    font-size: 28px;
  }
}
</style>
